import React, { useState, useEffect } from 'react';
import { Modal } from 'components';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import commonService from 'services/common-sensor-service';
import DashboardView from './DashboardView';

const sensor = [
  { id: '1', date: '2023-09-11 16:48:38 1', type: 'Critical', con: '문제 발생', stat: 0 },
  { id: '2', date: '2023-09-11 16:48:38 2', type: 'Normal', con: '정상 작동', stat: 1 },
];

export function Dashboard(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get('type') || '0';

  const [modalOpen, setModalOpen] = useState(false);
  const [filters, setFilters] = useState({ val1: '0' });
  const [sampleList, setSampleList] = useState({
    labels: [],
    data1: { name: '', data: [] },
    data2: { name: '', data: [] },
  });

  const dashboadData = async (name, val) => {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 1);
    const formattedStartDate = `${startDate.getFullYear()}${String(startDate.getMonth() + 1).padStart(2, '0')}${String(startDate.getDate()).padStart(2, '0')}000000`;

    const endDate = new Date();
    const formattedEndDate = `${endDate.getFullYear()}${String(endDate.getMonth() + 1).padStart(2, '0')}${String(endDate.getDate()).padStart(2, '0')}235959`;

    try {
      const newChartInputData = await commonService.getDashboadData(val, formattedStartDate, formattedEndDate);

      const defaultSampleList = { labels: [], data1: { name: '데이터 없음', data: [] }, data2: { name: '데이터 없음', data: [] } };

      const updatedSampleList = newChartInputData?.labels
        ? {
            labels: newChartInputData.labels,
            data1: newChartInputData.data1 || defaultSampleList.data1,
            data2: newChartInputData.data2 || defaultSampleList.data2,
          }
        : defaultSampleList;

      setSampleList(updatedSampleList);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      setSampleList({ labels: [], data1: { name: '에러 발생', data: [] }, data2: { name: '에러 발생', data: [] } });
    }
  };

  const onChange = (name, val) => {
    if (val === "0") {
      setSampleList({
        labels: [],
        data1: { name: '', data: [] },
        data2: { name: '', data: [] },
      });
      return;
    }
    setFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters, [name]: val };
      dashboadData(name, val); // 새로운 데이터를 가져옴
      return updatedFilters;
    });
  };

  useEffect(() => {
    if (type === '0' && location.pathname === '/dashboard') {
      setSearchParams({ type: '0' }, { replace: true });
    }
    const defaultName = 'val1';
    const defaultVal = '1';
    dashboadData(defaultName, defaultVal);
    setFilters((prevFilters) => ({ ...prevFilters, [defaultName]: defaultVal }));
  }, [type, setSearchParams]);

  return (
    <>
      <DashboardView
        filters={filters}
        onChange={onChange}
        sampleList={sampleList}
        sensorList={sensor}
      />
      <Modal open={modalOpen} title="Airconditioner"></Modal>
    </>
  );
}
